export default __webpack_public_path__ + "static/overpass-light-3cf2a42e777c572253a1b735fb2e8814.woff";